import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { media } from '../../utils/media-queries';

const NumberValue = ({ value, unit, description }) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <StyledNumberValue ref={ref}>
      <div className="number">
        <p className="value">
          <CountUp end={inView ? value : 0} />
        </p>
        <p className="unit">{unit}</p>
      </div>
      <p className="description">{description}</p>
    </StyledNumberValue>
  );
};

const StyledNumberValue = styled.div`
  width: 50%;
  padding-top: var(--sp-5);

  .number {
    display: flex;
    color: var(--red);
    font-weight: 500;
  }

  .value {
    font-size: 8rem;
    line-height: 1.2;
  }

  .unit {
    transform: translateY(var(--sp-1));
  }

  .description {
    width: 90%;
  }

  @media ${media.M} {
    .value {
      font-size: 12rem;
    }

    .unit {
      transform: translateY(var(--sp-2));
    }
  }
`;

NumberValue.propTypes = {
  value: PropTypes.number,
  unit: PropTypes.string,
  description: PropTypes.string,
};

export default NumberValue;
